import React from 'react';

import ChapterSectionProps from './props';
import './styles.scss';

const ChapterSection = ({ title, description, link, headingLevel: Heading = 'h3', ...props }: ChapterSectionProps) => {
  return (
    <a href={link} title={title} className="chapter-section" {...props}>
      <div className="chapter-section__title">
        <Heading className="chapter-section__heading">{title}</Heading>
        <span className="chapter-section__icon"></span>
      </div>
      <p className="chapter-section__description">{description}</p>
    </a>
  );
};

export default ChapterSection;

